/** Thema brand logo — the original Thema wordmark (same asset as the landing). */

export function Logo({ size = 26, markOnly = false }: { size?: number; markOnly?: boolean }) {
  // Collapsed contexts crop the wordmark away, leaving just the node mark.
  if (markOnly) {
    return (
      <div style={{ width: Math.round(size * 0.82), height: size, overflow: "hidden", display: "flex", alignItems: "center" }}>
        <img src="/Logo.svg" alt="Thema" style={{ height: size, width: "auto", maxWidth: "none", display: "block" }} />
      </div>
    );
  }
  return <img src="/Logo.svg" alt="Thema" style={{ height: Math.round(size * 1.02), width: "auto", display: "block" }} />;
}

/** Small OMT/asset mark — gradient-tinted square with a 2-letter ticker. */
export function OmtMark({ color, size = 34, ticker }: { color: string; size?: number; ticker?: string }) {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: 9,
        flex: "none",
        display: "grid",
        placeItems: "center",
        background: `linear-gradient(140deg, ${color}22, ${color}10)`,
        border: `1px solid ${color}33`,
        color,
        fontFamily: "var(--mono)",
        fontSize: size * 0.3,
        fontWeight: 600,
      }}
    >
      {ticker ? ticker.slice(0, 2) : ""}
    </div>
  );
}
